import {
  StyledSelect
} from "./chunk-ESCEBVFK.mjs";

// src/components/select/select-label.tsx
import React, { forwardRef } from "react";
var SelectLabel = forwardRef(
  function SelectLabel2(props, ref) {
    return /* @__PURE__ */ React.createElement(StyledSelect.Label, { ref, ...props });
  }
);

export {
  SelectLabel
};
